export const scrollToElement = (elem) => {
    window.scrollTo({
        top: (document.querySelector(elem).offsetTop - 85),
        behavior: "smooth"
    });
}